import { Component, Input } from '@angular/core';
import { MenuItem } from '../../services/menu.service';
import {AccessRulesService} from "../../../app/services/access-rules.service";

@Component({
  standalone: false,
  selector: 'cm-sub-menu',
  templateUrl: './sub-menu.component.html',
  styleUrls: ['./sub-menu.component.scss'],
})
export class SubMenuComponent {
  @Input() items: MenuItem[];

  constructor(
    private accessRulesService: AccessRulesService,
  ) {}

  hasAccess(item: MenuItem) {
    const accessProjects = this.accessRulesService.getAccessRulesValue().menu[item.type];

    let firstCondition = true;
    if (item.type in this.accessRulesService.getAccessMenuByFeature()) {
      firstCondition = this.accessRulesService.getAccessMenuByFeature()[item.type];
    }

    let secondCondition = true;
    if (this.accessRulesService.getAccessRulesValue().menu[item.type]) {
      secondCondition = this.accessRulesService.isAllowedByProfileRule(accessProjects);
    }

    return firstCondition && secondCondition;
  }
}
